import type { InputType } from '@ui-component-library/components/_deprecated/Input/Input.types';

const formatPhoneNumber = (digits: string): string => {
  const parts = {
    areaCode: digits.slice(0, 3),
    firstPart: digits.slice(3, 6),
    secondPart: digits.slice(6, 8),
    lastPart: digits.slice(8, 10)
  };

  if (digits.length <= 3) {
    return digits;
  }
  if (digits.length <= 6) {
    return `(${parts.areaCode}) ${parts.firstPart}`;
  }
  if (digits.length <= 8) {
    return `(${parts.areaCode}) ${parts.firstPart} ${parts.secondPart}`;
  }

  return `(${parts.areaCode}) ${parts.firstPart} ${parts.secondPart} ${parts.lastPart}`;
};

const formatIdentityNumber = (digits: string): string =>
  digits.length === 12 ? `${digits.slice(0, 8)}-${digits.slice(8, 12)}` : digits;

export const formatInputValue = (value: string, type: InputType): string => {
  const digits = value.replace(/\D/g, '');

  const formatters = {
    phone: formatPhoneNumber,
    identityNumber: formatIdentityNumber,
    email: () => value,
    text: () => value,
    number: () => value
  };

  return formatters[type](digits);
};
